import Immutable from 'immutable';
import {
  FLAG_GETTING_CARGO_DISTANCES,
  GET_CARGO_DISTANCES,
  CLEAR_CARGO_DISTANCES,
  FLAG_CARGO_DISTANCE_ACTIVITY,
  CLEAR_CARGO_DISTANCE,
  GET_CARGO_DISTANCE,
} from '../../../actions/types/cargo';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FLAG_GETTING_CARGO_DISTANCES:
      return state.setIn(['all', 'loading'], action.payload);
    case GET_CARGO_DISTANCES:
      return state.setIn(['all', 'content'], Immutable.Map(action.payload));
    case CLEAR_CARGO_DISTANCES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_CARGO_DISTANCE_ACTIVITY:
      if (action.payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(action.payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_CARGO_DISTANCE:
      return state.setIn(['current', 'content'], Immutable.Map(action.payload));
    case CLEAR_CARGO_DISTANCE:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
